/**
 * AAA IDP licence number reducer
 * 
 */
import { DELETE, LICENCE_NUMBER, VALIDATE } from '../../actions/types';
export const initialState = {
  error: false,
  required: true,
  valid: null,
  value: ''
};
const maxLength = 15;
export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE:
      return initialState;
    case LICENCE_NUMBER:
      {
        const {
          required
        } = state;
        const {
          value
        } = action;
        const empty = value === '' && required ? true : false;
        const long = value.length > maxLength ? true : false;
        const valid = empty || long ? false : true;
        return {
          ...state,
          error: !valid,
          valid,
          value
        };
      }
    case VALIDATE:
      {
        const {
          required,
          value
        } = state;
        const empty = value === '' && required ? true : false;
        const long = value.length > maxLength ? true : false;
        const valid = empty || long ? false : true;
        return {
          ...state,
          error: !valid,
          valid
        };
      }
    default:
      return state;
  }
}